module.exports = __webpack_public_path__ + "static/media/criacao-elementos-img-04.40ae9220.svg";